var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	80473: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [2,15,1,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 39609))))))),
	62739: () => (loadStrictSingletonVersionCheckFallback("default", "@ag-grid-community/core", [1,30,2,1], () => (__webpack_require__.e("node_modules_ag-grid-community_core_dist_esm_es6_main_mjs").then(() => (() => (__webpack_require__(/*! @ag-grid-community/core */ 70567))))))),
	14649: () => (loadStrictSingletonVersionCheckFallback("default", "@ag-grid-enterprise/core", [1,30,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ag-grid-community_core_ag-grid-community_core"), __webpack_require__.e("node_modules_ag-grid-enterprise_core_dist_esm_es6_main_mjs")]).then(() => (() => (__webpack_require__(/*! @ag-grid-enterprise/core */ 35301))))))),
	24673: () => (loadStrictSingletonVersionCheckFallback("default", "@ag-grid-enterprise/row-grouping", [1,30,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ag-grid-enterprise_core_ag-grid-enterprise_core"), __webpack_require__.e("default-node_modules_ag-grid-enterprise_row-grouping_dist_esm_es6_main_mjs")]).then(() => (() => (__webpack_require__(/*! @ag-grid-enterprise/row-grouping */ 77840))))))),
	65893: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 69593))))))),
	33635: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 22150))))))),
	17657: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [2,15,1,0], () => (__webpack_require__.e("default-node_modules_angular_common_fesm2020_common_mjs").then(() => (() => (__webpack_require__(/*! @angular/common */ 52954))))))),
	86739: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [2,15,1,0], () => (__webpack_require__.e("default-node_modules_angular_platform-browser_fesm2020_platform-browser_mjs").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 3878))))))),
	9812: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [2,15,1,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2020_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 52474))))))),
	82165: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [2,15,1,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2020_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 16873))))))),
	74617: () => (loadFallback("default", "@bkm-neon-micro-frontend/utility", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core"), __webpack_require__.e("default-libs_utility_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @bkm-neon-micro-frontend/utility */ 55538))))))),
	16354: () => (loadStrictSingletonVersionCheckFallback("default", "angular-oauth2-oidc", [1,13,0,1], () => (__webpack_require__.e("default-node_modules_angular-oauth2-oidc_fesm2020_angular-oauth2-oidc_mjs").then(() => (() => (__webpack_require__(/*! angular-oauth2-oidc */ 51010))))))),
	29714: () => (loadStrictSingletonVersionCheckFallback("default", "@auth0/angular-jwt", [1,5,2,0], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 14238))))))),
	5004: () => (loadStrictSingletonVersionCheckFallback("default", "@ngx-translate/core", [1,15,0,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs")]).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 79420))))))),
	28118: () => (loadStrictSingletonVersionCheckFallback("default", "@ngx-translate/http-loader", [1,8,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_http-loader_dist_fesm2022_ngx-translate-http-loader_mjs").then(() => (() => (__webpack_require__(/*! @ngx-translate/http-loader */ 86183))))))),
	59354: () => (loadStrictSingletonVersionCheckFallback("default", "@ag-grid-community/angular", [1,30,2,1], () => (__webpack_require__.e("default-node_modules_ag-grid-community_angular_fesm2015_ag-grid-community-angular_js").then(() => (() => (__webpack_require__(/*! @ag-grid-community/angular */ 564))))))),
	88711: () => (loadStrictSingletonVersionCheckFallback("default", "@group-ui/group-ui-angular", [0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_group-ui_group-ui-angular_dist_es2015_fesm2015_js")]).then(() => (() => (__webpack_require__(/*! @group-ui/group-ui-angular */ 54704))))))),
	18890: () => (loadFallback("default", "@bkm-neon-micro-frontend/auth", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ag-grid-enterprise_core_ag-grid-enterprise_core"), __webpack_require__.e("default-webpack_sharing_consume_default_angular-oauth2-oidc_angular-oauth2-oidc"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("default-libs_auth_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @bkm-neon-micro-frontend/auth */ 2745))))))),
	38093: () => (loadStrictSingletonVersionCheckFallback("default", "event-source-polyfill", [1,1,0,31], () => (__webpack_require__.e("node_modules_event-source-polyfill_src_eventsource_js").then(() => (() => (__webpack_require__(/*! event-source-polyfill */ 14871))))))),
	55497: () => (loadStrictSingletonVersionCheckFallback("default", "dompurify", [1,3,2,6], () => (__webpack_require__.e("node_modules_dompurify_dist_purify_es_mjs").then(() => (() => (__webpack_require__(/*! dompurify */ 71630))))))),
	5893: () => (loadFallback("default", "@bkm-neon-micro-frontend/internationalization", () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_http-loader_ngx-translate_http-loader"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @bkm-neon-micro-frontend/internationalization */ 1774))))))),
	82093: () => (loadStrictSingletonVersionCheckFallback("default", "dayjs", [1,1,11,9], () => (__webpack_require__.e("node_modules_dayjs_dayjs_min_js").then(() => (() => (__webpack_require__(/*! dayjs */ 73966))))))),
	75090: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [2,15,1,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_forms_fesm2020_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 93557))))))),
	1539: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations", [2,15,1,0], () => (__webpack_require__.e("node_modules_angular_animations_fesm2020_animations_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations */ 33950)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		80473
	],
	"default-webpack_sharing_consume_default_ag-grid-community_core_ag-grid-community_core": [
		62739
	],
	"default-webpack_sharing_consume_default_ag-grid-enterprise_core_ag-grid-enterprise_core": [
		14649
	],
	"default-webpack_sharing_consume_default_ag-grid-enterprise_row-grouping_ag-grid-enterprise_ro-5c0a8b": [
		24673
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		65893
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		33635
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		17657
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		86739
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		9812
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router-webpack_sharing_consume-d52d91": [
		82165,
		74617
	],
	"default-webpack_sharing_consume_default_angular-oauth2-oidc_angular-oauth2-oidc": [
		16354
	],
	"default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt": [
		29714
	],
	"default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core": [
		5004
	],
	"default-webpack_sharing_consume_default_ngx-translate_http-loader_ngx-translate_http-loader": [
		28118
	],
	"default-apps_neon_src_app_modules_feature_bkaview_services_savable-views_savable-views_servic-73ec1b": [
		59354,
		88711,
		18890,
		38093
	],
	"default-libs_ui_src_lib_components_footer-static-pages_footer_module_ts": [
		55497
	],
	"default-webpack_sharing_consume_default_bkm-neon-micro-frontend_internationalization_bkm-neon-37b55c": [
		5893
	],
	"default-libs_utility_src_index_ts": [
		82093
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		75090
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations-node_modules_d3-567520": [
		1539
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}